import { editorMode } from './data/data.editModes';

export const tool = {
  name: 'switch-mode',
  description:
    'Switches the editor mode for the 3D model. Available modes: object, material, scene.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      editMode: {
        type: 'string',
        description: 'The mode to switch to.',
        enum: editorMode,
      },
      message: {
        type: 'string',
        default: 'Modify model structure',
      },
    },
    required: ['editMode', 'message'],
  },
};
